// @flow
import { MUST_TRY_EXPERIENCES } from 'Client/cms/toolkit/constants';
import { ProductMustTryLine } from 'Components/lines/product-must-try-line/ProductMustTryLine.jsx';
import { productMustTryExperiencesResolver } from './productMustTryExperiences.resolver';

export const productMustTryExperiencesDescriptor = {
  name: MUST_TRY_EXPERIENCES,
  component: ProductMustTryLine,
  props: productMustTryExperiencesResolver.props,
  resolve: productMustTryExperiencesResolver.resolve,
};
